import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import v2_actionListSectorsByClient from "src/actions/v2/cliente/v2_actionListSectorsByClient";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";

const STATUS = [
  {
    value: "Pendente",
    label: "Pendente"
  },
  {
    value: "Atendendo",
    label: "Atendendo"
  }
];

const CardAssignChat = ({
  user,
  changeBlock,
  block
}) => {
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);

  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  let departmentsFormatted = departments?.map((department) => {
    return {
      value: department._id,
      label: department.nome_setor
    }
  });

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user?.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }


  async function getListSectors() {
    try {
      const response = await v2_actionListSectorsByClient(user?.clienteId);
      setDepartments(response.data.data)
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getUsers();
    getListSectors();
  }, []);


  return (
    <div className="w-full">
      <div className="space-y-4 flex flex-col gap-2">
        {/* Seleção de Usuário */}

        <div>
          <RadioGroup
            defaultValue={block?.data?.chatTypeTransfer}
            className="flex flex-row gap-2"
            onValueChange={(e) => {
              console.log('chatTypeTransfer', e)
              let event = {
                name: "chatTypeTransfer",
                value: e
              }
              changeBlock(event);
            }}
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="sector" id="r1" />
              <label htmlFor="r1">Setor</label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="user" id="r2" />
              <label htmlFor="r2">Usuário</label>
            </div>

          </RadioGroup>

        </div>
        <div className="space-y-4 flex flex-col gap-2">
          {block?.data?.chatTypeTransfer === "sector" && (
                  <div>
                  <label className="block text-sm font-medium">Setores</label>
      
                  <MultiSelect
                    options={departmentsFormatted}
                    onValueChange={(e) => {
                      let event = {
                        name: "chatDepartamentsAssign",
                        value: e
                      }
                      changeBlock(event);
                    }}
                    defaultValue={block?.data?.chatDepartamentsAssign}
                    placeholder="Selecionar setores"
                    variant="inverted"
                    animation={2}
                    maxCount={3}
                  />
                </div>
          )}


          {block?.data?.chatTypeTransfer === "user" && (
            <div>
              <label className="block text-sm font-medium">Usuários</label>
              <MultiSelect
                options={usersFormatted}
                onValueChange={(e) => {
                  let event = {
                    name: "chatUsersAssign",
                    value: e
                  }
                  changeBlock(event);
                }}
                defaultValue={block?.data?.chatUsersAssign}
                placeholder="Selecionar usuarios"
                variant="inverted"
                animation={2}
                maxCount={3}
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium mb-2">Status do Chat</label>
            <Select
              value={block?.data?.chatStatus}
              onValueChange={(e) => {
                let event = {
                  name: "chatStatus",
                  value: e
                }
                changeBlock(event);
              }}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione o status" />
              </SelectTrigger>
              <SelectContent>
                {STATUS.map((status) => (
                  <SelectItem key={status.value} value={status.value}>
                    {status.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

  
        </div>
      </div>
    </div>
  );
};

export default CardAssignChat;
